import clsx from "clsx";
import { bool, func, string } from "prop-types";

import classes from "./TextArea.module.scss";

const TextArea = ({
  value,
  onChange,
  onKeyDown,
  onKeyUp,
  placeholder,
  ariaLabel,
  resizable = false,
  className,
}) => (
  <textarea
    className={clsx(
      classes["textarea"],
      { [classes["textarea--resizable"]]: resizable },
      className
    )}
    value={value}
    onChange={onChange}
    onKeyDown={onKeyDown}
    onKeyUp={onKeyUp}
    placeholder={placeholder}
    aria-label={ariaLabel}
    data-testid="textarea"
  />
);

TextArea.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
  onKeyDown: func,
  onKeyUp: func,
  placeholder: string,
  ariaLabel: string,
  resizable: bool,
  className: string,
};

export default TextArea;
